import { useEffect, useState } from "react";
import Header from "../components/body/Header";
import Footer from "../components/body/Footer";
import Festivales from "../page/Festivales";
import apiAntesala from "../../config/ConfigPublic";

const FestivalesController = () => {
  const [festivalData, setFestivalData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetch = async () => {
    try {
      const response = await apiAntesala.get("/salas/festival/50039");
      if (response.status === 200 || response.status === 201) {
        setFestivalData(response.data);
      }
    } catch (error) {
      console.error("Error fetching festival data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <div className="container-fluid px-0" style={{ background: "#fff" }}>
      <div className="w-100 shadow-sm mb-1 fixed-top bg-white">
        <Header />
      </div>

      <div className="container-fluid px-0 min-vh-100">
        <Festivales data={festivalData} loading={loading} />
      </div>

      <div className="w-100 container-fluid px-0 mx-0">
        <Footer />
      </div>
    </div>
  );
};

export default FestivalesController;